import { render } from "./ShopInfo.vue?vue&type=template&id=15910e81&scoped=true"
import script from "./ShopInfo.vue?vue&type=script&lang=js"
export * from "./ShopInfo.vue?vue&type=script&lang=js"

import "./ShopInfo.vue?vue&type=style&index=0&id=15910e81&lang=scss&scoped=true"
import "./ShopInfo.vue?vue&type=style&index=1&id=15910e81&lang=scss"

import exportComponent from "D:\\CTL-Project\\ChatBotSHLX\\web-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15910e81"]])

export default __exports__